import type { PropsWithChildren } from 'react';
import React, { useContext } from 'react';
import {
  moveToElement,
  moveToNextOption,
  moveToPreviousOption,
} from '@fabric-app/business/search/utils/elements';

type SearchBarActionsContextProps = {
  focusNextOption: () => HTMLElement | null;
  focusPreviousOption: () => HTMLElement | null;
  focusSearchInput: () => void;
};

const SearchBarActionsContext = React.createContext<SearchBarActionsContextProps>(
  {} as SearchBarActionsContextProps,
);

type SearchBarActionsProviderProps = PropsWithChildren<{
  listBoxRef: React.RefObject<HTMLElement>;
}>;

export const useSearchBarActions = () => useContext(SearchBarActionsContext);

export const SearchBarActionsProvider: React.FC<SearchBarActionsProviderProps> = ({
  children,
  listBoxRef,
}) => {
  const focusNextOption = () => {
    if (!listBoxRef.current) return null;
    return moveToNextOption(listBoxRef.current);
  };

  const focusPreviousOption = () => {
    if (!listBoxRef.current) return null;
    return moveToPreviousOption(listBoxRef.current);
  };

  const focusSearchInput = () => {
    if (!listBoxRef.current) return;
    moveToElement(listBoxRef.current, 'input[role="input"]');
  };

  return (
    <SearchBarActionsContext.Provider
      value={{ focusNextOption, focusPreviousOption, focusSearchInput }}
    >
      {children}
    </SearchBarActionsContext.Provider>
  );
};
